import React, { useState } from "react";
import {
  AiFillApple,
  AiFillFacebook,
  AiFillGoogleCircle,
} from "react-icons/ai";
import { NavLink, useNavigate } from "react-router-dom";

import { apiURL } from "../api/index";

function Register() {
  const Navigate = useNavigate();
  const [message, setMessage] = useState("");

  const [name, setName] = useState("");
  const [city, setCity] = useState("Kohat");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpassword, setcPassword] = useState("");
  const [address, setAddress] = useState("");

  const register = async (e) => {
    e.preventDefault();

    const res = await fetch(`${apiURL}/register`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, address, city, password, cpassword }),
    });

    const data = await res.json();

    if (res.status === 400) {
      setMessage(data);
      setTimeout(() => {
        setMessage("");
      }, 2000);
    } else if (res.status === 420) {
      setMessage(data);
      setTimeout(() => {
        setMessage("");
      }, 2000);
    } else if (res.status === 200) {
      Navigate("/login");
      setMessage(data);
    } else if (res.status === 450) {
      setMessage(data);
      setTimeout(() => {
        setMessage("");
      }, 2000);
    }
  };

  return (
    <>
      {message && (
        <div className="bg-red-600 text-white p-2 w-full text-center font-semibold absolute">
          {message.message}
        </div>
      )}

      <div className="font-primary flex justify-center items-center w-[88%] mx-auto h-[100vh]">
        <div className="flex text-center bg-primary text-white rounded-2xl p-10 flex-col h-[85vh] md:w-[600px] my-10 justify-between">
          <h2 className="text-2xl font-semibold">Register Yourself</h2>
          <p className="my-2 text-sm w-96 text-center mx-auto">
            Hey, Enter your details to get yourself register and create an
            account
          </p>
          <input
            className="register-input"
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name..."
          />
          <select
            name="city"
            className="register-input"
            onChange={(e) => setCity(e.target.value)}
            type="text"
            value={city}
          >
            <option value="Kohat">Kohat</option>
            <option value="Peshawar">peshawar</option>
            <option value="Islamabad">Islamabad</option>
          </select>
          <input
            className="register-input"
            type="text"
            name="address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Enter The Exact Delivery Address..."
          />

          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="register-input"
            type="text"
            name="email"
            placeholder="Enter Email..."
          />
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="register-input"
            type="password"
            name="password"
            placeholder="Passcode..."
          />
          <input
            value={cpassword}
            onChange={(e) => setcPassword(e.target.value)}
            className="register-input"
            type="password"
            name="cpassword"
            placeholder="Confirm Passcode..."
          />
          <button
            onClick={(e) => register(e)}
            className="my-2 border border-black-200 bg-secondary text-white rounded-lg p-2 outline-none"
          >
            Register
          </button>
          <span className="text-sm my-4">- Or Sign in with -</span>
          <div className="flex justify-around">
            <div className="flex border border-black-200 p-4 m-2">
              <button>
                <AiFillGoogleCircle />
              </button>
              <span>Google</span>
            </div>
            <div className="flex border border-black-200 p-4 m-2">
              <button>
                <AiFillFacebook />
              </button>
              <span>Facebook</span>
            </div>
            <div className="flex border border-black-200 p-4 m-2">
              <button>
                <AiFillApple />
              </button>
              <span>Apple ID</span>
            </div>
          </div>
          <span className="text-sm my-2">
            Already have an account?
            <button className="text-secondary font-semibold pl-1">
              <NavLink to="/login">Login</NavLink>
            </button>
          </span>
        </div>
      </div>
    </>
  );
}

export default Register;
